import { CashActions } from "@/components/cash/CashActions";
import { brl, fmtDateTime, CASH_MOVE_LABELS } from "@/lib/api";

const Stat = ({ l, v, cls = "", testId }) => (
  <div className="rounded-lg bg-muted/50 p-3"><p className="text-xs text-muted-foreground">{l}</p><p className={`font-mono text-lg font-bold ${cls}`} data-testid={testId}>{v}</p></div>
);

export function CashSessionCard({ item, manager, onChanged }) {
  const { session: c, summary: s } = item;
  const ticket = c.kind === "ticket";
  return (
    <div className="card-surface space-y-4 p-4" data-testid={`cash-session-${c.number}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="font-display text-lg font-semibold">{ticket ? `Venda ticket · ${(c.user_names || [])[0] || ""}` : "Caixa PDV"} <span className="font-mono text-sm text-muted-foreground">#{c.number}</span></p>
          <p className="text-xs text-muted-foreground">Aberto por {c.opened_by} em {fmtDateTime(c.opened_at)}</p>
          {!ticket && <p className="mt-1 text-xs" data-testid={`cash-session-users-${c.number}`}>Usuários liberados: {c.user_names?.length ? c.user_names.join(", ") : "todos"}</p>}
        </div>
        {manager && <div className="flex flex-wrap gap-2"><CashActions item={item} onChanged={onChanged} extended /></div>}
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
        <Stat l="Valor inicial" v={brl(c.opening_amount)} testId={`cash-stat-opening-${c.number}`} />
        <Stat l={`Vendas (${s.sales_count})`} v={brl(s.sales_total)} cls="text-emerald-600" testId={`cash-stat-sales-${c.number}`} />
        <Stat l="Suprimentos" v={brl(s.suprimentos)} testId={`cash-stat-suprimentos-${c.number}`} />
        <Stat l="Sangrias" v={brl(s.sangrias)} cls="text-red-500" testId={`cash-stat-sangrias-${c.number}`} />
        <Stat l="Dinheiro esperado" v={brl(s.expected_cash)} testId={`cash-expected-${c.number}`} />
      </div>
      {c.movements.length > 0 && (
        <ul className="divide-y rounded-lg border text-sm" data-testid={`cash-movements-${c.number}`}>
          {c.movements.map((m) => <li key={m.id} className="flex justify-between gap-2 px-3 py-2"><span>{CASH_MOVE_LABELS[m.type]} · {m.note || "—"}<span className="block text-xs text-muted-foreground">{fmtDateTime(m.at)} · {m.user}</span></span><span className={`font-mono ${["sangria", "saida"].includes(m.type) ? "text-red-500" : "text-emerald-500"}`}>{brl(m.amount)}</span></li>)}
        </ul>
      )}
    </div>
  );
}
